import { Utils } from "../../../../../../services/utils.service";
import { DataCollection } from "../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../infrastructure/enums";
import { TransportData } from "../../../../../infrastructure/transportdata";

export class DashboardDrilldownFetchRequest {
  public static readonly FetchRequestType: string = "dashboard_drilldown_fetch_request";

  // the only thing that changes per card/segment
  drill_down_request_type: number = 0;
  drill_down_sub_type: number = 0;
  sub_dashboard_filter_by: number = 0;
  sub_dashboard_child_filter_by: number = 0;

  financial_year_ids: number[] = [];
  report_filter_type: number = 0;
  month: number = 0;
  quarterly_year_type: number = 0;
  half_year_type: number = 0;
  from_date: string = '';
  to_date: string = '';

  state_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  bcm_post_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  asha_employee_record_ids: number[] = [];
  af_post_ids: number[] = [];
  login_user_id: number = 0;
  is_pagenation_required: number = 1;

  // Server-side remote pagination, sorting, search, and timestamp parameters
  skip: number = 0;
  take: number = 20;
  order_by_column: string = '';
  order_direction: string = '';
  request_date_time: string = '';
  search_text: string = '';

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData, DashboardDrilldownFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  }

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);
    return td;
  }
}